import wretch from 'wretch';
import queryString from 'wretch/addons/queryString';

// API URL constants
export const AUTH_API_URL = '/authorization';
export const OOPS_API_URL = '/oops';
export const REFERENCE_API_URL = '/reference';
export const PERFORMANCE_API_URL = '/performance';

/** Singleton for base wretcher. Bearer token is added on login. */
export const fmhAPI = { base: wretch(process.env.REACT_APP_BASE_URL).addon(queryString) };

/** Separate base for auth calls, allowing a different host (e.g. dev gateway) when running the API locally. */
export const authBaseAPI = {
    base: wretch(process.env.REACT_APP_AUTH_BASE_URL ?? process.env.REACT_APP_BASE_URL).addon(
        queryString,
    ),
};

export const localAPI = { base: fmhAPI.base.url('http://localhost:8000') };
